import { Customer } from '../../../../../services/entities/impl/blfApi/schemas/customer';

/**
 * Utility function to filter customers based on customer ID
 * @param customers - Array of customers to filter
 * @param filterCustomerID - Customer ID to filter by
 * @returns Filtered array of customers
 */
export const filterCustomers = (
  customers: Customer[] | undefined,
  filterCustomerID: string
): Customer[] => {
  if (!customers) return [];

  // First filter the customers based on the filterCustomerID if provided
  if (filterCustomerID !== '') {
    return customers.filter((customer) => customer.id === filterCustomerID);
  }

  return customers;
};
